import { ArrowDown } from "lucide-react";
import { HERO, IMAGES, scrollToId } from "../../lib/content";
import { Logo } from "./Logo";
import { CountLine } from "./CountLine";
import { Countdown } from "./Countdown";

export const Hero = ({ count, storeLinks }) => (
  <section id="hero" data-testid="hero-section" className="relative min-h-[100svh] overflow-hidden bg-[#2C221E]">
    <img
      src={IMAGES.hero.src}
      srcSet={IMAGES.hero.srcSet}
      sizes="100vw"
      alt={IMAGES.hero.alt}
      fetchPriority="high"
      data-testid="hero-background-image"
      className="hero-img absolute inset-0 h-full w-full object-cover object-[60%_center]"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-[#2C221E]/80 via-[#2C221E]/45 to-[#2C221E]/5" />
    <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#2C221E]/60 to-transparent" />

    <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-7xl flex-col px-6 sm:px-10 lg:px-16">
      <div className="pt-8 fade-up">
        <Logo light halo="#3a2c25" testId="hero-logo" />
      </div>

      <div className="flex flex-1 flex-col justify-center py-20 max-w-2xl">
        <p className="fade-up text-xs sm:text-sm uppercase tracking-[0.3em] text-[#F2C98F] font-semibold" style={{ animationDelay: "120ms" }}>
          Arriving before Christmas 2026
        </p>
        <Countdown links={storeLinks} />
        <h1 data-testid="hero-title" className="fade-up mt-5 font-serif text-6xl sm:text-7xl lg:text-8xl font-light tracking-tight text-[#FDFBF7] leading-none" style={{ animationDelay: "220ms" }}>
          {HERO.title}
        </h1>
        <p data-testid="hero-tagline" className="fade-up mt-6 font-serif italic text-2xl sm:text-3xl lg:text-4xl text-[#FDFBF7] leading-snug" style={{ animationDelay: "340ms" }}>
          {HERO.tagline}
        </p>
        <p data-testid="hero-subheading" className="fade-up mt-5 text-base sm:text-lg text-[#F4EBDD]/90 max-w-lg leading-relaxed" style={{ animationDelay: "460ms" }}>
          {HERO.sub}
        </p>
        <div className="fade-up mt-10 flex flex-col sm:flex-row gap-4" style={{ animationDelay: "580ms" }}>
          <button data-testid="hero-join-waitlist-button" onClick={() => scrollToId("waitlist")} className="btn-primary">
            Join the Waitlist
          </button>
          <button data-testid="hero-learn-more-button" onClick={() => scrollToId("sound-familiar")} className="btn-ghost-light group">
            Learn More
            <ArrowDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
          </button>
        </div>
        <CountLine count={count} testId="hero-counter" className="fade-up mt-6 text-[#F4EBDD]/90" />
      </div>
    </div>
  </section>
);
